import { Component, inject, OnInit, signal } from '@angular/core';
import { ContainerComponent } from '../../core/components/block/container/container.component';
import { BreadCrumbsComponent } from '../../core/components/ui/bread-crumbs/bread-crumbs.component';
import { BreadCrumbService } from '../../core/services/bread-crumb.service';
import { IBreadCrumb } from '../../core/interface/bread-crumb';
import { SearchInputComponent } from '../../core/components/block/search-input/search-input.component';
import { RegulatoryActsListComponent } from '../../core/components/block/regulatory-acts/regularoty-acts-list/regulatory-acts-list.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { PaginatorComponent } from '../../core/components/ui/paginator/paginator.component';
import {
  AppliedFilter,
  FilterOption,
  FiltersComponent,
} from '../../core/components/block/fitlers/filters.component';
import { PageModel } from '../../core/models/page.models';
import { ActivatedRoute, Router } from '@angular/router';
import { RegulatoryPraService } from '../../core/services/regulatory-pra.service';
import { RegulatoryPraModel } from '../../core/models/regulatory-pra.model';

@Component({
  selector: 'app-regulatory-acts',
  imports: [
    ContainerComponent,
    BreadCrumbsComponent,
    SearchInputComponent,
    RegulatoryActsListComponent,
    NgxPaginationModule,
    PaginatorComponent,
    FiltersComponent,
  ],
  templateUrl: './regulatory-acts.component.html',
  standalone: true,
  styleUrl: './regulatory-acts.component.scss',
})
export class RegulatoryActsComponent implements OnInit {
  private regulatoryPraService = inject(RegulatoryPraService);
  private breadCrumbService = inject(BreadCrumbService);
  page: PageModel | null = null;
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  pra = signal<RegulatoryPraModel[]>([]);

  breadCrumbs: IBreadCrumb[] = [
    { labels: ['Головна'], to: '/' },
    { labels: ['Проєкти регуляторних актів'], to: 'acts' },
  ];

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.currentPage = Number(params['page']) || 1;
      this.getList();
    });

    this.route.data.subscribe((data) => {
      this.pra.set(data['pra']);
      this.page = data['page'];
    });
    this.breadCrumbService.breadCrumbs.set(this.breadCrumbs);
    this.getFilters();
  }

  getFilters() {
    this.regulatoryPraService.getFilterOptions().subscribe((data) => {
      this.filterOptions = [
        {
          id: 'regActTypeTitle',
          label: this.page?.translation?.data?.filter1,
          options: data.regActTypeTitles.map((value: string) => ({
            value,
            label: value,
          })),
        },
        {
          id: 'regDomains',
          label: this.page?.translation?.data?.filter2,
          options: data.regDomains.map((value: string) => ({
            value,
            label: value,
          })),
        },
        {
          id: 'actTerritoryTypeTitle',
          label: this.page?.translation?.data?.filter3,
          options: data.actTerritoryTypeTitles.map((value: string) => ({
            value,
            label: value,
          })),
        },
        {
          id: 'authorizedUnit',
          label: this.page?.translation?.data?.filter4,
          options: data.authorizedUnits.map((value: string) => ({
            value,
            label: value,
          })),
        },

        {
          id: 'dateScalePreset',
          label: this.page?.translation?.data?.filter5,
          options: [
            { value: 'last_week', label: 'Останній тиждень' },
            { value: 'last_month', label: 'Останній місяць' },
            { value: 'last_year', label: 'Останній рік' },
          ],
        },
        {
          id: 'publishedPreset',
          label: this.page?.translation?.data?.filter6,
          options: [
            { value: 'last_week', label: 'Останній тиждень' },
            { value: 'last_month', label: 'Останній місяць' },
            { value: 'last_quarter', label: 'Останній квартал' },
          ],
        },
      ];
    });
  }

  onSearch(query: string) {
    if (!query || !query.trim()) {
      delete this.filter.title;
    } else {
      this.filter.title = query.trim();
    }
    this.currentPage = 1;
    this.getList();
  }

  filter: any = {};

  totalItems: number = 0;
  currentPage: number = 1;
  itemsPerPage: number = 8;

  onPageChange(page: number) {
    this.currentPage = page;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { page },
      queryParamsHandling: 'merge',
    });
    this.getList();
  }

  updatePaginatedList() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.pra().slice(start, end);
  }

  filterOptions: FilterOption[] = [];
  appliedFilters: AppliedFilter[] = [];

  onFiltersChanged(filters: AppliedFilter[]): void {
    this.appliedFilters = filters;

    this.filter = {};
    for (const f of filters) {
      this.filter[f.filterId] = f.value;
    }

    this.currentPage = 1;
    this.getList();
  }

  getList() {
    this.filter.take = this.itemsPerPage;
    this.filter.skip = (this.currentPage - 1) * this.itemsPerPage;

    this.regulatoryPraService.list(this.filter).subscribe({
      next: (data) => {
        this.pra.set(data.data);

        if (this.appliedFilters.length > 0) {
          this.totalItems = data.data.length;
        } else {
          this.totalItems = data.count;
        }

        this.updatePaginatedList();
      },
    });
  }
}
